import { BULK_ID_MODAL_REDUCER_KEY, BulkIdRegisterModalStatus } from './constants';

export function bulkIdRegisterModalState(state) {
  return state.get(BULK_ID_MODAL_REDUCER_KEY);
}

export function isLoading(state) {
  const status = bulkIdRegisterModalState(state).get('status');
  return status === BulkIdRegisterModalStatus.LOADING;
}

export function isFinished(state) {
  const status = bulkIdRegisterModalState(state).get('status');
  return status === BulkIdRegisterModalStatus.SUCCESS || status === BulkIdRegisterModalStatus.NOT_FOUND;
}
